import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';

import {
  MatCommonModule,
  MatLineModule,
  MatNativeDateModule,
  MatPseudoCheckboxModule,
  MatRippleModule,
} from '@angular/material/core';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';

import { FilePondModule, registerPlugin } from 'ngx-filepond';

import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '@app/@shared';
import { TranslateLandPipe } from '@app/@shared/pipe/translate-land.pipe';

import { ClientEditComponent } from './client_edit.component';
import { KontakteComponent } from '../kontakte/kontakte.component';

// Import modules for embedded components
import { StandorteModule } from '../standorte/standorte.module';
import { DokumenteModule } from '../dokumente/dokumente.module';

import { DatePipe } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatRippleModule,
    //MatStepperModule,
    MatCardModule,
    //MatTooltipModule,
    MatGridListModule,
    MatSlideToggleModule,
    MatRadioModule,
    FilePondModule,

    NgbPopoverModule,

    SharedModule,
    
    // Embedded component modules
    StandorteModule,
    DokumenteModule,
  ],
  exports: [ClientEditComponent],
  declarations: [
    ClientEditComponent,
    KontakteComponent, // KontakteComponent doesn't have its own module
  ],
  providers: [DatePipe],
})
export class ClientEditModule {}
